import en from 'src/l10n/en.json'
import es from 'src/l10n/es.json'
import it from 'src/l10n/it.json'

export default { en, es, it }



// WEBPACK FOOTER //
// ./src/l10n/messages.js